<template>
  <li class="only_ship c_only_ship DELUXE" style="display: list-item" v-if="stateroomShow">
    <div class="c_first_box list_box fix stateroomOnly">
      <div class="f-fl">
        <div class="img_box stateroomImage">
          <img
              :src="stateroomImageUrl(stateroomFirst)"
              @click="onStateroomClicked($event, stateroomFirst, 1)"
              :alt="stateroomFirst.isQiaohu"
          />
          <img
              class="group_type_tag"
              v-if="stateroomFirst.groupType === 'QIAOHU'"
              src="https://resource.rcclchina.com.cn/QIAOHU/qiaohu.png"
          />
<!--          <img-->
<!--              class="group_type_tag"-->
<!--              v-else-if="stateroomFirst.groupType === 'STARRYSKY'"-->
<!--              src="https://resource.rcclchina.com.cn/STARRYSKY/PC/PC_icon.png"-->
<!--          />-->
        </div>
      </div>

      <div class="f-fl">
        <div class="ship_info" :class="[stateroomFirst.roomSummaryList && stateroomFirst.roomSummaryList.length>0 && stateroomFirst.suiteType > 0?'ship_info_bottom':'']">
          <div class="ship_title">
            {{ stateroomName(stateroomFirst) }}
            <img class="deluxe-tag"
                 v-if="stateroomType === 'DELUXE' && stateroomFirst.suiteType >= 0"
                 @click="onShowStateroomSuitePopup(stateroomFirst.suiteImageUrl)"
                 :src="GlobalData.suiteTagImgValue[stateroomFirst.suiteType]"/>
            <i
                v-else-if="getStateroomTage(stateroomFirst).length > 0"
                class="offer_label suite_label"
                @click="onShowStateroomSuitePopup(stateroomFirst.suiteImageUrl)"
            >{{ getStateroomTage(stateroomFirst) }}</i
            >
          </div>
          <div class="ship_parameter">
            <span>舱房：{{ stateroomFirst.stateroomArea || '--' }}</span>
            <span>阳台：{{ stateroomBalconyArea(stateroomFirst) || '--' }}</span>
            <span>楼层：{{ stateroomFirst.stateroomFloorInfo || '--' }}</span>
          </div>
          <template v-if="stateroomFirst.stateroomType === 'DELUXE' && stateroomFirst.suiteType >= 0">
            <DeviceFeatureTags :view-num="2" is-detail
                                :tags="stateroomFirst.deviceFeatureTags"
                                :stateroom="stateroomFirst"
                                :idx="1"
                                @submit="onStateroomClicked"></DeviceFeatureTags>
          </template>
          <template v-else>
            <DeviceFeatureTags is-detail :tags="stateroomFirst.deviceFeatureTags"
                                :stateroom="stateroomFirst"
                                :idx="1"
                                @submit="onStateroomClicked"></DeviceFeatureTags>
          </template>

          <div v-if="stateroomFirst.roomSummaryList && stateroomFirst.roomSummaryList.length>0 && stateroomFirst.suiteType > 0"
            class="summ-box"
            @click="onShowStateroomSuitePopup(stateroomFirst.suiteImageUrl)"
            >
            <div class="summ-box-list">
              <div class="summ-box-item"
              :class="[stateroomFirst.suiteType == 1 ? 'tab-room-box-see':stateroomFirst.suiteType == 2 ? 'tab-room-box-sky':'tab-room-box-star']"
              v-for="item in stateroomFirst.roomSummaryList" :key="item">{{ item }}</div>
            </div>
            <div class="summ-box-list"
              :class="[stateroomFirst.suiteType == 1 ? 'tab-room-box-see':stateroomFirst.suiteType == 2 ? 'tab-room-box-sky':'tab-room-box-star']"
            >
              {{stateroomFirst.suiteRightsCount}}项 
              <img class="summ-box-item-img" v-if="stateroomFirst.suiteType == 1" :src="currImgUrl+'see.png'" alt="">
              <img class="summ-box-item-img" v-else-if="stateroomFirst.suiteType == 2" :src="currImgUrl+'sky.png'" alt="">
              <img class="summ-box-item-img" v-else-if="stateroomFirst.suiteType == 3" :src="currImgUrl+'star.png'" alt="">
            </div>
          </div>

        </div>
        <div class="price nrpPrice">
          <div class="price-num">
            {{ priceType(1) }}(含税)
            <em class="symbol">￥</em>
            <span class="num">{{ netAmountStr(stateroomFirst, 1) }}</span>
            <em>/人起</em>
            <span v-if="firstAmountPerNight" class="average-price">平均每晚￥{{firstAmountPerNight}}/人起</span>
          </div>
<!--          <del class="original_price">-->
<!--            零售指导价(含税)￥{{ originalAmountStr(stateroomFirst) }}/人起-->
<!--          </del>-->
          <div
              class="return_label"
              @click="onSelectNrpChange($event, stateroomFirst, 1)"
          >
            <span
                class="js-NRPPrice"
                :class="{ cur: firstSelectNrp }"
                v-show="hasNrp(stateroomFirst)"
            >{{ getNrpTitle(true) }}</span
            >
            <span
                class="js-UnNRPPrice"
                :class="{ cur: !firstSelectNrp }"
                v-show="hasRp(stateroomFirst)"
            >{{ getNrpTitle(false) }}</span
            >
          </div>

          <NrpDotTag
              :isNrp="firstSelectNrp"
              :isFortyEightHoursNrpCruise="isFortyEightHoursNrpCruise"
              :showRow="showRow"
          />
          <FourPeopleBookingTag v-if="stateroomFirst.stateroomCategoryCode === 'US'" />
          <!--特殊礼遇-->
          <div class="specialBookingStateroom_title" v-if="isBirthday">
            <span>支持收费附加服务:</span>
            <span
                class="button"
                @click="onShowStateroomSuitePopup(specialBookingInfo.image)"
            >
              <img
                  src="https://resource.rcclchina.com.cn/wechatMiniProgram/WechatMiniProgramImage/birthdayRoom/birthday_icon.png"
                  alt=""
              />
              {{ "皇家生日礼遇" }}
            </span>
          </div>
        </div>

        <div class="f-fr errMsg hid"></div>
      </div>
    </div>
    <img
        class="connect_pic"
        src="https://resource.rcclchina.com.cn/ConnectStateroom/connect_pic.png"
        alt=""
    />
    <div class="connect_gif" @click="showConnectRoomPopup">
      <div class="img_wrap"></div>
    </div>
    <div class="c_second_box list_box fix stateroomOnly">
      <div class="f-fl">
        <div class="img_box stateroomImage">
          <img
              :src="stateroomImageUrl(stateroomSecond)"
              @click="onStateroomClicked($event, stateroomSecond, 2)"
          />
          <img
              class="group_type_tag"
              v-if="stateroomSecond.groupType === 'QIAOHU'"
              src="https://resource.rcclchina.com.cn/QIAOHU/qiaohu.png"
          />
<!--          <img-->
<!--              class="group_type_tag"-->
<!--              v-else-if="stateroomSecond.groupType === 'STARRYSKY'"-->
<!--              src="https://resource.rcclchina.com.cn/STARRYSKY/PC/PC_icon.png"-->
<!--          />-->
        </div>
      </div>
      <div class="f-fl">
        <div class="ship_info" :class="[stateroomSecond.roomSummaryList && stateroomSecond.roomSummaryList.length>0 && stateroomSecond.suiteType > 0?'ship_info_bottom':'']">
          <div class="ship_title">
            {{ stateroomName(stateroomSecond) }}
            <img class="deluxe-tag"
                 v-if="stateroomType === 'DELUXE' && stateroomSecond.suiteType >= 0"
                 @click="onShowStateroomSuitePopup(stateroomSecond.suiteImageUrl)"
                 :src="GlobalData.suiteTagImgValue[stateroomSecond.suiteType]"/>
            <!--            <i-->
            <!--              v-else-if="getStateroomTage(stateroomSecond).length > 0"-->
            <!--              class="offer_label suite_label"-->
            <!--              @click="onShowStateroomSuitePopup(stateroomSecond.suiteImageUrl)"-->
            <!--              >{{ getStateroomTage(stateroomSecond) }}</i>-->
          </div>
          <div class="ship_parameter">
            <span>舱房：{{ stateroomSecond.stateroomArea || '--' }}</span>
            <span>阳台：{{ stateroomBalconyArea(stateroomSecond) || '--' }}</span>
            <span>楼层：{{ stateroomSecond.stateroomFloorInfo || '--' }}</span>
          </div>
          <template v-if="stateroomSecond.stateroomType === 'DELUXE' && stateroomSecond.suiteType >= 0">
            <DeviceFeatureTags :view-num="2" is-detail
                                :tags="stateroomSecond.deviceFeatureTags"
                                :stateroom="stateroomSecond"
                                :idx="2"
                                @submit="onStateroomClicked"></DeviceFeatureTags>
          </template>
          <template v-else>
            <DeviceFeatureTags is-detail :tags="stateroomSecond.deviceFeatureTags"
                                :stateroom="stateroomSecond"
                                :idx="2"
                                @submit="onStateroomClicked"></DeviceFeatureTags>
          </template>

          <div v-if="stateroomSecond.roomSummaryList && stateroomSecond.roomSummaryList.length>0 && stateroomSecond.suiteType > 0"
            class="summ-box"
            @click="onShowStateroomSuitePopup(stateroomSecond.suiteImageUrl)"
            >
            <div class="summ-box-list">
              <div class="summ-box-item"
              :class="[stateroomSecond.suiteType == 1 ? 'tab-room-box-see':stateroomSecond.suiteType == 2 ? 'tab-room-box-sky':'tab-room-box-star']"
              v-for="item in stateroomSecond.roomSummaryList" :key="item">{{ item }}</div>
            </div>
            <div class="summ-box-list"
              :class="[stateroomSecond.suiteType == 1 ? 'tab-room-box-see':stateroomSecond.suiteType == 2 ? 'tab-room-box-sky':'tab-room-box-star']"
            >
              {{stateroomSecond.suiteRightsCount}}项 
              <img class="summ-box-item-img" v-if="stateroomSecond.suiteType == 1" :src="currImgUrl+'see.png'" alt="">
              <img class="summ-box-item-img" v-else-if="stateroomSecond.suiteType == 2" :src="currImgUrl+'sky.png'" alt="">
              <img class="summ-box-item-img" v-else-if="stateroomSecond.suiteType == 3" :src="currImgUrl+'star.png'" alt="">
            </div>
          </div>

        </div>

        <div class="price nrpPrice">
          <div class="price-num">
            {{ priceType(2) }}(含税)
            <em class="symbol">￥</em>
            <span class="num">{{ netAmountStr(stateroomSecond, 2) }}</span>
            <em>/人起</em>
            <span v-if="secondAmountPerNight" class="average-price">平均每晚￥{{secondAmountPerNight}}/人起</span>
          </div>
<!--          <del class="original_price">-->
<!--            零售指导价(含税)￥{{ originalAmountStr(stateroomSecond) }}/人起-->
<!--          </del>-->

          <div
              class="return_label"
              @click="onSelectNrpChange($event, stateroomSecond, 2)"
          >
            <span
                class="js-NRPPrice"
                :class="{ cur: secondSelectNrp }"
                v-show="hasNrp(stateroomSecond)"
            >{{ getNrpTitle(true) }}</span
            >
            <span
                class="js-UnNRPPrice"
                :class="{ cur: !secondSelectNrp }"
                v-show="hasRp(stateroomSecond)"
            >{{ getNrpTitle(false) }}</span
            >
          </div>
          <NrpDotTag
              :isNrp="secondSelectNrp"
              :isFortyEightHoursNrpCruise="isFortyEightHoursNrpCruise"
              :showRow="showRow"
          />
          <FourPeopleBookingTag v-if="stateroomSecond.stateroomCategoryCode === 'US'" />
          <!--特殊礼遇-->
          <div class="specialBookingStateroom_title" v-if="isBirthday">
            <span>支持收费附加服务:</span>
            <span
                class="button"
                @click="onShowStateroomSuitePopup(specialBookingInfo.image)"
            >
              <img
                  src="https://resource.rcclchina.com.cn/wechatMiniProgram/WechatMiniProgramImage/birthdayRoom/birthday_icon.png"
                  alt=""
              />
              {{ "皇家生日礼遇" }}
            </span>
          </div>
        </div>
      </div>
      <div class="f-fr c_f-fr">
        <div class="detail_add_btn">
          <span
              class="less"
              :class="{ disabled: shoppingCartNum == 0 }"
              @click="shoppingCartDelete($event)"
          >
          </span>

          <input
              type="text"
              class="stateroomNumber"
              :value="shoppingCartNum"
              placeholder="0"
              readonly="readonly"
          />

          <span class="add" @click="connectShoppingCartAdd($event)"> </span>
        </div>
        <div class="c_txt c_text">已经帮您算好了哦，</div>
        <div class="c_total c_text">
          两间{{ guestNumber }}人总价￥<span class="connect-total-amount">{{
            connectAmountStr()
          }}</span>
        </div>
<!--        <div class="c_surplus_room_num">*该房型仅剩2间</div>-->
      </div>
      <div class="f-fr errMsg" v-show="errMsg && errMsg.length > 0">
        <div class="errMsgText" v-html="errMsg"></div>
        <img
            src="https://resource.rcclchina.com.cn/tui2/info/close.png"
            class="clean"
            @click="closeErrMsg"
        />
      </div>
    </div>
    <div class="hover-bg"></div>
  </li>
</template>

<script>
import nrpConfig from "@/utilities/nrpConfig";
import bookingHelper from "@/utilities/bookingHelper";
import { SpecialBookingType } from "@/utilities/specialBookingHelper";
import {gioTracking} from "@/utilities/tools";
const NrpDotTag = () => import("@/components/Booking/NrpDotTag.vue");
const DeviceFeatureTags = ()=> import("@/components/Cruise/CruiseDetail/DeviceFeatureTags.vue");
const FourPeopleBookingTag = () => import("@/components/Booking/FourPeopleBookingTag.vue");
export default {
  name: "ConnectStateroomItem",
  components: {
    NrpDotTag,
    DeviceFeatureTags,
    FourPeopleBookingTag
  },
  props: {
    shipCode: {
      type: String,
    },
    sailDate: {
      type: String,
    },
    packageCode: {
      type: String,
    },
    connectStateroom: {
      type: Object,
      default() {
        return {};
      },
    },
    stateroomType: {
      type: String,
    },
    shoppingCarts: {
      type: Array,
      default() {
        return [];
      },
    },
    onConnectShoppingCartAdd: {
      type: Function,
    },
    onShoppingCartDelete: {
      type: Function,
    },
    showStateroomDetail: {
      type: Function,
    },
    showStateroomSuitePopup: {
      type: Function,
    },
    showConnectRoomPopup: {
      type: Function,
    },
    isFortyEightHoursNrpCruise: {
      type: Boolean,
    },
    specialBookingInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    suiteTagSelected: {
      type: Number,
      default: -1
    },
    nrpDefaultSelectedType: {
      type: Number
    },
    index: {
      type: Number
    },
    showRow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      stateroomShow: true,
      firstSelectNrp: true,
      secondSelectNrp: true,
      errMsg: "",
      errMsgTimeout: null,
      currImgUrl: process.env.VUE_APP_IMG_URL + '/wechatMiniProgram/routesDetail/housingSelection/',
      imgUrl: process.env.VUE_APP_IMG_URL
    };
  },
  beforeMount() {
    this.initSelectNrp();
  },
  methods: {
    initSelectNrp() {
      this.initSelectNrpByStateroom(this.stateroomFirst, 1);
      this.initSelectNrpByStateroom(this.stateroomSecond, 2);
    },
    initSelectNrpByStateroom(stateroom, stateroomIndex) {
      if (!stateroom.price || stateroom.price.length == 0) {
        return;
      }
      let nrp = 0;
      const nrpPrice = stateroom.price.filter((r) => r.isnrp);
      nrp = nrpPrice.length > 0 ? nrpPrice[0].netAmount : 0;
      let rp = 0;
      const rpPrice = stateroom.price.filter((r) => !r.isnrp);
      rp = rpPrice.length > 0 ? rpPrice[0].netAmount : 0;

      // 暂时默认显示RP
      // if (nrp > 0 && nrp <= rp) {
      //     if (stateroomIndex == 1) {
      //         this.firstSelectNrp = true
      //     } else {
      //         this.secondSelectNrp = true
      //     }
      // } else {
      //     if (stateroomIndex == 1) {
      //         this.firstSelectNrp = false
      //     } else {
      //         this.secondSelectNrp = false
      //     }
      // }

      //nrpDefaultSelectedType 0:默认-按nrp 1:常规rp | 2:收费nrp
      if (rp > 0 && nrp > 0) {
        if (stateroomIndex == 1) {
          this.firstSelectNrp = this.nrpDefaultSelectedType === 0 || this.nrpDefaultSelectedType === 2;
        } else {
          this.secondSelectNrp = this.nrpDefaultSelectedType === 0 || this.nrpDefaultSelectedType === 2;
        }
      } else if (rp > 0) {
        if (stateroomIndex == 1) {
          this.firstSelectNrp = false;
        } else {
          this.secondSelectNrp = false;
        }
      } else if (nrp > 0) {
        if (stateroomIndex == 1) {
          this.firstSelectNrp = true;
        } else {
          this.secondSelectNrp = true;
        }
      }
    },
    stateroomName(stateroom) {
      let name = stateroom.stateroomCNName + "_" + this.categoryCode(stateroom);
      let guestCountText = bookingHelper.getStateroomGuestNumber(
          stateroom.guestNumber
      );
      if (guestCountText.length > 0) {
        name += `(${guestCountText})`;
      }
      return name;
    },
    stateroomBalconyArea(stateroom) {
      if (
          !stateroom.stateroomBalconyArea ||
          stateroom.stateroomBalconyArea.length == 0 ||
          stateroom.stateroomBalconyArea == "无"
      ) {
        return "无阳台";
      }
      return stateroom.stateroomBalconyArea;
    },
    stateroomImageUrl(stateroom) {
      if (stateroom.stateroomImages && stateroom.stateroomImages.length > 0) {
        return stateroom.stateroomImages[0];
      }
      return stateroom.stateroomImgUrl;
    },
    getStateroomTage(stateroom) {
      if (stateroom.tag && stateroom.tag.length > 0) {
        return stateroom.tag;
      } else if (stateroom.suiteType == 1) {
        return "银卡礼遇";
      } else if (stateroom.suiteType == 2) {
        return "金卡礼遇";
      }

      return "";
    },
    priceType(stateroomIndex) {
      let isnrp =
          stateroomIndex == 1 ? this.firstSelectNrp : this.secondSelectNrp;
      if (isnrp) {
        return nrpConfig.nrp.priceType;
      }
      return nrpConfig.rp.priceType;
    },
    getNrpTitle(isNrp) {
      if (this.isFortyEightHoursNrpCruise) {
        return nrpConfig.fortyEightHoursNrp.title;
      } else if (isNrp) {
        return nrpConfig.nrp.title;
      }
      return nrpConfig.rp.title;
    },
    nrpTitle(stateroomIndex) {
      let isnrp =
          stateroomIndex == 1 ? this.firstSelectNrp : this.secondSelectNrp;
      if (isnrp) {
        return nrpConfig.nrp.title;
      }
      return nrpConfig.rp.title;
    },
    nrpText(stateroomIndex) {
      let isnrp =
          stateroomIndex == 1 ? this.firstSelectNrp : this.secondSelectNrp;
      if (isnrp) {
        return nrpConfig.nrp.description;
      } else {
        return nrpConfig.rp.description;
      }
    },
    netAmountByCabin(stateroom, stateroomIndex) {
      let isnrp =
          stateroomIndex == 1 ? this.firstSelectNrp : this.secondSelectNrp;
      let price = 0;
      const priceObj = stateroom.price.filter((r) => r.isnrp == isnrp);
      price = priceObj.length > 0 ? priceObj[0].netAmount : 0;
      return price;
    },
    netAmountPerGuest(stateroom, stateroomIndex) {
      const price = this.netAmountByCabin(stateroom, stateroomIndex);
      return price / stateroom.guestNumber;
    },
    netAmountStr(stateroom, stateroomIndex) {
      let price = this.netAmountPerGuest(stateroom, stateroomIndex);
      if (price == 0) {
        return "";
      }
      return price.toFixed(0);
    },
    originalAmountStr(stateroom) {
      let price = stateroom.originalAmount;
      if (price == 0) {
        return "";
      }
      return (price / stateroom.guestNumber).toFixed(0);
    },
    connectAmountStr() {
      const price =
          this.netAmountByCabin(this.stateroomFirst, 1) +
          this.netAmountByCabin(this.stateroomSecond, 2);
      return price.toFixed(0);
    },

    hasNrp(stateroom) {
      return stateroom.price && stateroom.price.some((r) => r.isnrp);
    },
    hasRp(stateroom) {
      return stateroom.price && stateroom.price.some((r) => !r.isnrp);
    },
    isQiaohu(stateroom) {
      return stateroom.groupType && stateroom.groupType == "QIAOHU";
    },
    categoryCode(stateroom) {
      let code = stateroom.stateroomCategoryCode + "";
      if (code.indexOf("_") >= 0) {
        code = code.split("_")[0];
      }
      return code;
    },
    onSelectNrpChange(e, stateroom, stateroomIndex) {
      e.stopPropagation();
      if (stateroomIndex == 1) {
        this.firstSelectNrp = this.changeSelectNrp(
            stateroom,
            stateroomIndex,
            this.firstSelectNrp
        );
      } else {
        this.secondSelectNrp = this.changeSelectNrp(
            stateroom,
            stateroomIndex,
            this.secondSelectNrp
        );
      }
    },
    changeSelectNrp(stateroom, stateroomIndex, selectNrp) {
      if (selectNrp == false && this.hasNrp(stateroom, stateroomIndex)) {
        selectNrp = true;
      } else if (selectNrp == true && this.hasRp(stateroom, stateroomIndex)) {
        selectNrp = false;
      }
      return selectNrp;
    },
    // 连通房加购物车，需要把两间都加进去
    async connectShoppingCartAdd(e) {
      e.stopPropagation();
      const first = this.shoppingCartAdd(
          this.stateroomFirst,
          this.firstSelectNrp
      );
      if (!first) return;
      const second = this.shoppingCartAdd(
          this.stateroomSecond,
          this.secondSelectNrp
      );
      if (!second) return;
      this.gioTrackConnectRoom(first);
      this.gioTrackConnectRoom(second);
      const errMsg = await this.onConnectShoppingCartAdd([first, second]);
      if (errMsg && errMsg.length > 0) {
        this.showErrMsg(errMsg);
      }
    },
    shoppingCartAdd(stateroom, selectNrp) {
      const price = stateroom.price.filter((r) => r.isnrp == selectNrp);
      if (!price || price.length == 0) {
        return;
      }
      const model = {
        shipCode: this.shipCode,
        sailDate: this.sailDate,
        productPackageId: -1,
        packageId: this.packageCode,
        stateroomCategoryCode: stateroom.stateroomCategoryCode,
        stateroomClass: this.stateroomType,
        fareCode: price[0].fareCode,
        guestNumber: stateroom.guestNumber,
        originAmount: price[0].originalAmount / stateroom.guestNumber,
        netAmount: price[0].netAmount / stateroom.guestNumber,
        amountPerNight: price[0].amountPerNight,
        isNrp: selectNrp,
        groupAgencyId: "",
        groupAgencyName: "",
        requestsequence: "",
        groupType: "",
        groupId: "",
        connectId: this.connectStateroom.connectId,
      };
      return model;
    },
    gioTrackConnectRoom (model) {
      gioTracking("track", "AddRoom", {
        GuestNumber: model.guestNumber,
        RoomClass: model.stateroomClass,
        RoomCategory: model.stateroomCategoryCode,
        RoomType: 'Connecting',
        shipCode: this.shipCode,
        sailDate: this.sailDate
      });
    },
    // 删除购物车，由于接口支持删除其中一间房间后，把对应另外一间连通房也删掉，所以前端只需要删一间房间就可以了
    shoppingCartDelete(e) {
      e.stopPropagation();
      if (this.shoppingCartNum > 0) {
        const price = this.stateroomFirst.price;
        const model = {
          shipCode: this.shipCode,
          sailDate: this.sailDate,
          productPackageId: -1,
          packageId: this.packageCode,
          stateroomCategoryCode: this.stateroomFirst.stateroomCategoryCode,
          stateroomClass: this.stateroomType,
          fareCode: price[0].fareCode,
          guestNumber: this.stateroomFirst.guestNumber,
          originAmount: price[0].originalAmount / this.stateroomFirst.guestNumber,
          netAmount: price[0].netAmount / this.stateroomFirst.guestNumber,
          isNrp: this.firstSelectNrp,
          groupAgencyId: "",
          groupAgencyName: "",
          requestsequence: "",
          groupType: "",
          groupId: "",
          connectId: this.connectStateroom.connectId,
        };
        this.onShoppingCartDelete(model);
      }
    },
    onStateroomClicked(e, stateroom, stateroomIndex) {
      e.stopPropagation();
      gioTracking('track', 'evt_RoomDetailClick', {
        'GuestNumber': stateroom.guestNumber,
        'RoomType': 'Connecting',
        'RoomClass': stateroom.stateroomType,
        'RoomCategory': stateroom.stateroomCategoryCode,
        'shipCode': this.shipCode,
        'sailDate': this.sailDate
      });
      const stateroomData = {
        stateroomImages: stateroom.stateroomImages,
        stateroomName: stateroom.stateroomCNName,
        stateroomCategory: stateroom.stateroomCategoryCode,
        stateroomPriceType: this.priceType(stateroomIndex),
        stateroomPrice: this.netAmountPerGuest(stateroom, stateroomIndex),
        stateroomCapacity: stateroom.stateroomCapacity,
        stateroomArea: stateroom.stateroomArea,
        stateroomBalcony: stateroom.stateroomBalconyArea,
        stateroomFloor: stateroom.stateroomFloorInfo,
        isQiaohu: stateroom.groupType == 'QIAOHU',
        isStarrySky: stateroom.groupType == 'STARRYSKY',
        isPcpGiftTheme: stateroom.groupType == 'PCPGIFT',
        isCustomTheme: stateroom.groupType == 'CUSTOM',
        isNrp: stateroomIndex == 1 ? this.firstSelectNrp : this.secondSelectNrp,
        stateroomDescription: stateroom.stateroomDescription,
        stateroomNrpTitle: this.nrpTitle(stateroomIndex),
        stateroomNrpText: this.nrpText(stateroomIndex),
        guestNumber: stateroom.guestNumber,
        stateroomTag: stateroom.suiteType || null,
        stateroomType: stateroom.stateroomType || null,

        stateroomImageDataList: stateroom.stateroomImageDataList,
        roomSummaryList: stateroom.roomSummaryList,
        suiteRightsCount: stateroom.suiteRightsCount,
        vrUrl: stateroom.vrUrl,
        suiteType: stateroom.suiteType,
        suiteImageUrl: stateroom.suiteImageUrl,

        deviceFeatureTags: stateroom.deviceFeatureTags,
        deviceGroupTags: stateroom.deviceGroupTags,

        roomListIndex: this.index,
        stateroomIndex: stateroomIndex,
        personalizedStateroomInfo: stateroom.personalizedStateroomInfo
      };
      console.log("onStateroomClicked",stateroomData);
      // TODO 连通房详情-去掉条件可以正常弹出
      if(!stateroomData) this.showStateroomDetail(stateroomData);
      this.showStateroomDetail(stateroomData);
    },
    onShowStateroomSuitePopup(suiteImage) {
      if (suiteImage && suiteImage.length > 0 && this.shipCode !== 'OV') {
        this.showStateroomSuitePopup(suiteImage);
      }
    },
    onShowConnectRoomPopup() {
      this.showConnectRoomPopup();
    },
    showErrMsg(errMsg) {
      this.errMsg = errMsg;
      if (this.errMsgTimeout) {
        clearTimeout(this.errMsgTimeout);
      }
      this.errMsgTimeout = setTimeout(this.closeErrMsg, 5000);
    },
    closeErrMsg() {
      this.errMsg = "";
      if (this.errMsgTimeout) {
        clearTimeout(this.errMsgTimeout);
        this.errMsgTimeout = null;
      }
    },
  },
  computed: {
    firstAmountPerNight() {
      if(this.stateroomFirst.price.length === 1) {
        return this.stateroomFirst.price[0]?.amountPerNight ? this.stateroomFirst.price[0].amountPerNight.toFixed(0) : null;
      }
      if(this.firstSelectNrp) {
        return this.stateroomFirst.price[0]?.amountPerNight ? this.stateroomFirst.price[0].amountPerNight.toFixed(0) : null;
      } else {
        return this.stateroomFirst.price[1]?.amountPerNight ? this.stateroomFirst.price[1].amountPerNight.toFixed(0) : null;
      }
    },
    secondAmountPerNight() {
      if(this.stateroomSecond.price.length === 1) {
        return this.stateroomSecond.price[0]?.amountPerNight ? this.stateroomSecond.price[0].amountPerNight.toFixed(0) : null;
      }
      if(this.secondSelectNrp) {
        return this.stateroomSecond.price[0]?.amountPerNight ? this.stateroomSecond.price[0].amountPerNight.toFixed(0) : null;
      } else {
        return this.stateroomSecond.price[1]?.amountPerNight ? this.stateroomSecond.price[1].amountPerNight.toFixed(0) : null;
      }
    },
    stateroomFirst() {
      return this.connectStateroom.connectStateroomFirsts;
    },
    stateroomSecond() {
      return this.connectStateroom.connectStateroomSeconds;
    },
    shoppingCartNum() {
      const first = this.shoppingCarts.filter(
          (r) =>
              r.connectId &&
              r.connectId.length > 0 &&
              r.berthedCategoryCode == this.stateroomFirst.stateroomCategoryCode &&
              r.isnrp == this.firstSelectNrp &&
              r.bookingShoppingCart
      );
      if (first.length == 0) {
        return 0;
      }
      const firstId = first[0].bookingShoppingCart.id;

      const hasSecond = this.shoppingCarts.some(
          (r) =>
              r.connectId &&
              r.connectId.length > 0 &&
              r.berthedCategoryCode == this.stateroomSecond.stateroomCategoryCode &&
              r.isnrp == this.secondSelectNrp &&
              r.bookingShoppingCart &&
              r.bookingShoppingCart.id != firstId
      );

      if (hasSecond) {
        return 2;
      }
      return 0;
    },
    guestNumber() {
      return this.stateroomFirst.guestNumber + this.stateroomSecond.guestNumber;
    },
    isBirthday() {
      if (
          this.specialBookingInfo &&
          this.specialBookingInfo.specialBookingType > 0
      ) {
        return (
            this.specialBookingInfo.specialBookingType ==
            SpecialBookingType.Birthday
        );
      }
      return false;
    },
  },
  watch: {
    suiteTagSelected(val) {
      if(this.stateroomFirst.suiteImageUrl || this.stateroomSecond.suiteImageUrl) {
        let tagFirstSuiteType = this.stateroomFirst.suiteType;
        let firstStateroomType = this.stateroomFirst.stateroomType;
        let tagSecondSuiteType = this.stateroomSecond.suiteType;
        let secondStateroomType = this.stateroomSecond.stateroomType;
        this.stateroomShow = true;
        if (val === 1) {
          this.stateroomShow = (firstStateroomType === 'DELUXE' && tagFirstSuiteType === 1) || (secondStateroomType === 'DELUXE' && tagSecondSuiteType === 1);
        } else if (val === 2) {
          this.stateroomShow = (firstStateroomType === 'DELUXE' && tagFirstSuiteType === 2) || (secondStateroomType === 'DELUXE' && tagSecondSuiteType === 2);
        } else if (val === 3) {
          this.stateroomShow = (firstStateroomType === 'DELUXE' && tagFirstSuiteType === 3) || (secondStateroomType === 'DELUXE' && tagSecondSuiteType === 3);
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.summ-box{
  width: 600px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.summ-box-list{
  display: flex;
  align-items: center;
}
.summ-box-item{
  margin-right: 8px;
  border: 1px solid;
  padding: 4px 10px;
  border-radius: 4px;
}
.summ-box-item-img{
  width: 14px;
  height: 14px;
}
.tab-room-box-see{
  color: #43797D;
  border-color: #43797D;
}
.tab-room-box-sky{
  color: #3D60AF;
  border-color: #3D60AF;
}
.tab-room-box-star{
  color: #8B3C63;
  border-color: #8B3C63;
}
.ship_info_bottom{
  margin-bottom: 10px !important;
}
li {
  margin-bottom: 10px;
  border: 1px solid #d3dadd;
  border-right: 0;
  position: relative;
  .list_box {
    border-right: 7px solid #fbc500;
    padding: 10px;
    position: relative;
    .img_box {
      position: relative;
      width: 280px;
      height: 200px;
      overflow: hidden;
      margin-right: 30px;
      img {
        width: 100%;
        cursor: pointer;
        height: 100%;
      }
      & .group_type_tag {
        position: absolute;
        top: 12px;
        right: 10px;
        z-index: 1;
        height: 28px;
        width: auto;
      }
    }
    .offer_label {
      line-height: 23px;
      padding: 0 20px;
      background-color: #fffae7;
      border-radius: 12px;
      border: solid 1px #ffa70d;
      display: inline-block;
      font-size: 12px;
      color: #ffa70d;
      font-weight: normal;
      margin: 0 10px;
      vertical-align: middle;
      cursor: pointer;
    }
    .deluxe-tag {
      margin: -2px 10px 0;
      height: 23px;
      vertical-align: middle;
      cursor: pointer;
    }
    .ship_parameter {
      font-size: 14px;
      color: #a6aeb1;
      span {
        display: inline-block;
        vertical-align: middle;
        margin-right: 10px;
        padding-right: 10px;
        position: relative;
      }
      span::after {
        content: "";
        display: block;
        width: 1px;
        height: 12px;
        background: #b4b4b4;
        position: absolute;
        right: 0;
        bottom: 3px;
      }
      span:last-child::after {
        background: transparent;
      }
    }
    .ship_tags {
      margin-top: 8px;
      & .tag {
        display: inline-block;
        margin-right: 25px;

        & > img {
          display: inline-block;
          height: 14px;
          margin-right: 5px;
        }
        & > div {
          line-height: 14px;
          font-size: 13px;
          color: #282b2c;
          display: inline-block;
        }
      }
    }
    .stateroom_detail {
      cursor: pointer;
      color: #2b77bd;
      & > span {
        display: inline-block;
        margin-right: 4px;
      }
      & > img {
        margin-bottom: 2px;
        display: inline-block;
      }
    }
    .price {
      .price-num {
        font-size: 14px;
        height: 34px;
        color: #282b2c;
        em {
          color: #ff3022;
          font-style: normal;
          font-weight: bold;
        }
        & .symbol {
          font-size: 18px;
          height: 34px;
        }
        .num {
          color: #ff3022;
          font-size: 28px;
          font-weight: bold;
          line-height: 34px;
        }
        .average-price {
          margin-left: 25px;
          color: #a6aeb1;
        }
      }
      .c_offer_price {
        font-size: 14px;
        margin-bottom: 5px;
        em {
          color: #ff3022;
          font-style: normal;
          font-weight: bold;
          font-size: 20px;
        }
        .num {
          color: #ff3022;
          font-size: 20px;
          font-weight: bold;
        }
      }
    }
    .original_price {
      font-size: 14px;
      display: block;
    }
    .return_label {
      font-size: 0;
      display: inline-block;
      margin-top: 10px;
      cursor: pointer;
      margin-right: 5px;
      background: url(https://resource.rcclchina.com.cn/tui2/list/NRP_Bg.png)
      no-repeat;
      background-size: 100% 100%;
      filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='https://resource.rcclchina.com.cn/tui2/list/NRP_Bg.png',sizingMethod='scale');
      -ms-filter: "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='https://resource.rcclchina.com.cn/tui2/list/NRP_Bg.png',sizingMethod='scale')";
      span {
        width: 75px;
        display: inline-block;
        height: 25px;
        line-height: 25px;
        border-radius: 13px;
        font-size: 12px;
        text-align: center;
      }
      .cur {
        background: url(https://resource.rcclchina.com.cn/tui2/list/NRP_Selected.png)
        no-repeat;
        background-size: 100% 100%;
        filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='https://resource.rcclchina.com.cn/tui2/list/NRP_Selected.png',sizingMethod='scale');
        -ms-filter: "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='https://resource.rcclchina.com.cn/tui2/list/NRP_Selected.png',sizingMethod='scale')";
        color: #fff;
      }
    }
    .specialBookingStateroom_title {
      font-size: 0px;
      display: inline-block;
      margin-top: 16px;
      margin-right: 5px;
      background-size: 100% 100%;
      span {
        width: 137px;
        display: inline-block;
        color: #818181;
        height: 25px;
        line-height: 25px;
        border-radius: 13px;
        font-size: 14px;
        text-align: center;
      }
      .button {
        text-align: left;
        display: inline-block;
        height: 25px;
        line-height: 25px;
        border-radius: 13px;
        font-size: 14px;
        color: #BA9153;
        cursor: pointer;
      }
      img {
        //height: 27px;
        width: 27px;
      }
    }
    .f-fr {
      margin: 90px 46px 0px 0px;
      position: relative;
      z-index: 2;
    }
    .f-fr.c_f-fr {
      margin-top: 58px;
      margin-right: 16px;
    }
    .errMsg {
      margin: 5px -101px 0px 0px;
      color: white;
      height: 50px;
      background: rgb(51, 136, 199);
      align-items: center;
      padding: 5px 10px 5px 28px;
      bottom: 60px;
      position: absolute;
      right: 150px;
      top: auto;
      display: flex;
      img {
        cursor: pointer;
      }
      .errMsgText {
        padding-right: 10px;
      }
    }
    .detail_add_btn {
      margin-bottom: 14px;
      span {
        position: relative;
        width: 30px;
        height: 30px;
        border: 1px solid #d3dadd;
        background: #fff;
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
      }
      input {
        width: 36px;
        height: 30px;
        border: none;
        padding: 0;
        margin: 0 3px;
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        font-style: normal;
      }
      span:after {
        width: 18px;
        height: 2px;
        left: 50%;
        margin-left: -8px;
        top: 13px;
      }
      .add:before {
        height: 18px;
        width: 2px;
        left: 50%;
        top: 13px;
        margin-top: -8px;
      }
    }
    .detail_add_btn span:after,
    .detail_add_btn span:before {
      content: "";
      display: block;
      position: absolute;
      background: #016bb9;
    }
    .detail_add_btn .disabled:after,
    .detail_add_btn .disabled:before {
      background: #a6aeb1;
    }
    .c_text {
      color: #282b2c;
      font-size: 14px;
      font-weight: 400;
    }
    .c_surplus_room_num {
      color: #ff3022;
    }
    .ship_info {
      margin: 4px 0 24px;
      .ship_title {
        font-size: 22px;
        color: #282b2c;
        font-weight: bold;
        margin-bottom: 10px;
        a {
          display: inline-block;
          font-size: 16px;
          color: #0073bb;
          margin-left: 10px;
          vertical-align: middle;
          font-weight: normal;
          line-height: 23px;
          cursor: pointer;
        }
      }
    }
  }
  .c_first_box {
    padding-bottom: 0;
  }
  .c_second_box {
    padding-top: 0;
  }
  .connect_pic {
    position: absolute;
    left: 10px;
    top: 195px;
    z-index: 999;
    width: 280px;
  }
  .connect_gif {
    height: 152px;
    width: 152px;
    position: absolute;
    top: 54px;
    right: 34px;
    z-index: 9;
    cursor: pointer;
    overflow: hidden;
    .img_wrap {
      height: 648px;
      width: 810px;
      position: relative;
      transform: translate3d(-5px, -5px, 0);
      animation-name: connect_frames;
      animation-duration: 1.2s;
      animation-timing-function: step-start;
      animation-delay: 0s;
      animation-iteration-count: infinite;
      animation-direction: normal;
      animation-fill-mode: none;
      background-image: url(https://resource.rcclchina.com.cn/connectRoom/connectSprite2.png);
    }
  }
  .hover-bg {
    right: 0 !important;
    background-image: url(https://resource.rcclchina.com.cn/cruiseDetail/pc/pc_c_bg.png);
    background-repeat: no-repeat;
    background-position: top right;
    background-size: 100% 100%;
    position: absolute;
    width: 0px;
    top: 0px;
    right: -7px;
    height: 100%;
    -webkit-transition: width 0.5s ease;
    -o-transition: width 0.5s ease;
    -moz-transition: width 0.5s ease;
    transition: width 0.5s ease;
  }
}

.c_only_ship:hover .hover-bg {
  width: 222px;
  -webkit-transition: width 0.5s ease;
  -o-transition: width 0.5s ease;
  -moz-transition: width 0.5s ease;
  transition: width 0.5s ease;
}

@keyframes connect_frames {
  0% {
    transform: translate3d(-5px, -5px, 0px);
  }
  5.5556% {
    transform: translate3d(-167px, -5px, 0px);
  }
  11.1111% {
    transform: translate3d(-329px, -5px, 0px);
  }
  16.6667% {
    transform: translate3d(-491px, -5px, 0px);
  }
  22.2222% {
    transform: translate3d(-5px, -167px, 0px);
  }
  27.7778% {
    transform: translate3d(-167px, -167px, 0px);
  }
  33.3333% {
    transform: translate3d(-329px, -167px, 0px);
  }
  38.8889% {
    transform: translate3d(-491px, -167px, 0px);
  }
  44.4444% {
    transform: translate3d(-5px, -329px, 0px);
  }
  50% {
    transform: translate3d(-167px, -329px, 0px);
  }
  55.5556% {
    transform: translate3d(-329px, -329px, 0px);
  }
  61.1111% {
    transform: translate3d(-491px, -329px, 0px);
  }
  66.6667% {
    transform: translate3d(-5px, -491px, 0px);
  }
  72.2222% {
    transform: translate3d(-167px, -491px, 0px);
  }
  77.7778% {
    transform: translate3d(-329px, -491px, 0px);
  }
  83.3333% {
    transform: translate3d(-491px, -491px, 0px);
  }
  88.8889% {
    transform: translate3d(-653px, -5px, 0px);
  }
  94.4444% {
    transform: translate3d(-653px, -167px, 0px);
  }
  100% {
    transform: translate3d(-653px, -329px, 0px);
  }
}
</style>
